// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3v4b5","header":"Messages_header__2IA8m"};